import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';

@Injectable()
export class AvatarFileUploadService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(ConfigService);

    uploadFile(partyId: string, file: File): Observable<HttpEvent<any>> {
        const formData = new FormData();
        formData.append(file.name, file);

        return this.http.request(
            new HttpRequest(
                'PUT',
                `${
                    this.config.getConfiguration().API_BASE
                }/party/${partyId}/avatar`,
                formData,
                {
                    reportProgress: true,
                }
            )
        );
    }
}
